import { Typography, Card, CardContent, Box } from "@mui/material";
import { useLocation, Navigate } from 'react-router-dom'
import { getOrderById } from '../http/orderAPI'
import { useEffect, useState } from 'react'

const PageSuccess = () => {

    const location = useLocation();
    const pathArray = location.pathname.split('/')
    const orderId = pathArray[pathArray.length - 1]

    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(true)
    const [invalidOrder, setInvalidOrder] = useState(false)

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const data = await getOrderById(orderId)

                // 🔴 проверка ответа
                if (!data || data.orderId === null) {
                    setInvalidOrder(true)
                    return
                }

                setOrder(data)
            } catch (e) {
                console.error(e)
                setInvalidOrder(true)
            } finally {
                setLoading(false)
            }
        }

        if (orderId) {
            fetchOrder()
        }
    }, [orderId])

    if (!orderId || invalidOrder) {
        return <Navigate to="/" />;
    }

    if (loading) {
        return <Typography align="center">Загрузка...</Typography>
    }



    return (
        <Card>
            <CardContent>
                <Box>
                    <Typography align='center' variant="h4" sx={{ mb: 2, mt: 2 }}>
                        Оплата по вашему заказу # {orderId} <br />прошла успешно
                    </Typography>
                    <Box display='flex' justifyContent='center' alignItems='center'>
                        <svg width="100px" height="100px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#00f1ff" d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z" /></svg>
                    </Box>
                    <Typography align='center' sx={{ mt: 2 }}>
                        Средства зарезервированы в системе до завершения сделки.
                    </Typography>
                    <Typography align='center' sx={{ mt: 2 }}>
                        Пришлите чек об оплате в нашу поддержку: support@smartcoinseller.com или <br />
                        в Telegram — @coingold_support.
                    </Typography>
                    <Typography align='center'>
                        После выполнения условий сделки вы получите уведомление на указанный вами e-mail
                        <br /> для подтверждения оказания услуги.
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}

export default PageSuccess;